import { Action, createReducer, on } from '@ngrx/store';
import * as RidersActions from '../actions/riders.actions';
import { RiderDTO, Rider, RidersFilters } from '../../commons/models/riders';

export interface RidersState {
    list: RiderDTO[],
    total: number,
    includes: string[],
    currentPage: number,
    perPage: number,
    order: string,
    direction: string,
    filters: RidersFilters,
    dialogId: string,
    selectionDialogId: string,
    selectedRiders: Rider[],
    selectedTenantId: number;
};

const initialState: RidersState = {
    list: [],
    total: 0,
    includes: [],
    currentPage: 1,
    perPage: 25,
    order: null,
    direction: null,
    filters: null,
    dialogId: null,
    selectionDialogId: null,
    selectedTenantId: 1,
    selectedRiders: []
};

const ridersReducer = createReducer(
    initialState,
    on(RidersActions.loadRidersCompleted, (state, {riders, currentPage, total, perPage, order, direction, filters, includes}) => {
        return { ...state, list: riders, currentPage, total, perPage, order, direction, filters, includes };
    }),
    on(RidersActions.riderDialogOpened, (state, {dialogId}) => {
        return {...state, dialogId};
    }),

);

export function reducer(state: RidersState | undefined, action: Action) {
    return ridersReducer(state, action);
}